import React from 'react';
import { Button } from '@ui5/webcomponents-react';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const ExportExcelButton = ({ data, fileName = 'tabla_bultos.xlsx' }) => {
  const exportToExcel = () => {
    if (!data || data.length === 0) {
      alert('No hay datos para exportar.');
      return;
    }

    // Agregar Pos con numeración progresiva
    const formattedData = data.map((item, index) => ({
      Pos: index + 1, // Inicia en 1 y se incrementa automáticamente
      Material: item.materialCode || '',
      Cantidad: item.quantity || '',
      Unidad: item.pricePerUnit || '',
      Bulto: item.bultoNumber || ''
    }));

    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Bultos');

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const dataBlob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8' });
    saveAs(dataBlob, fileName);
  };

  return (
    <Button icon="download" onClick={exportToExcel} style={{ backgroundColor: 'green', color: 'white' }}>
      Exportar
    </Button>
  );
};

export default ExportExcelButton;
